import React from 'react'
import ProjectHeader from './ProjectHeader'
import ProjectRow from './ProjectRow'

const ProjectTable = ({data}) =>{
    console.log(data)
  return (
    <div>

        <ProjectHeader/>
        <ProjectRow data={data}/>
    
        
    </div>
  )
}

export default ProjectTable